<template>
  <div class="mall-recent-keywords">
    <div class="mall-recent-keywords__clear" @click="$emit('clear')">전체 삭제</div>
    <div class="mall-recent-keywords__list">
      <div
        v-for="keyword in keywords"
        :key="keyword"
        class="mall-recent-keywords__item"
        @click="$emit('select', keyword)"
      >
        <img class="mall-recent-keywords__clock" src="@/assets/mall/icn_clock_line.svg" alt="" />
        <span class="mall-recent-keywords__text">{{ keyword }}</span>
        <div class="mall-recent-keywords__remove" @click.stop="$emit('remove', keyword)">
          <img src="@/assets/mall/icn_closed_line.svg" alt="삭제" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 최근 검색어 (최신순)
export default {
  name: 'MallRecentKeywords',
  props: {
    keywords: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.mall-recent-keywords {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.mall-recent-keywords__clear {
  padding: 0 2px;
  border-radius: 4px;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;
}

.mall-recent-keywords__list {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 2px;
}

.mall-recent-keywords__item {
  display: flex;
  padding: 12px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  cursor: pointer;
}

.mall-recent-keywords__clock {
  display: block;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.mall-recent-keywords__text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mall-recent-keywords__remove {
  display: flex;
  flex-shrink: 0;
}

.mall-recent-keywords__remove img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallRecentKeywords.vue